import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPost, axiosPut, axiosPatch } from './axiosUtils';
import './axiosInterceptor';

const InventoryService = {

  async getInventoryList(campaignId: string): AxiosUtilsType {
    return await axiosGet(`inventory/campaign?id=${campaignId}`);
  },

  async createInventory(inventory: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`inventory/create`, inventory);
  },

  async getInventoryDetails(selectedRowId: string): AxiosUtilsType {
    return await axiosGet(`inventory/list/${selectedRowId}`);
  },

  async updateInventory(selectedRowId: string, inventory: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`inventory/list/${selectedRowId}`, inventory);
  },

  async deleteInventory(selectedRowId: string): AxiosUtilsType {
    return await axiosPatch(`inventory/list/${selectedRowId}`);
  },

  async getRandomReward(inventory: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`inventory/reward`,inventory);
  },
};
export default InventoryService;
